import {
    Megaphone,
    UserCheck,
    Mail,
    LineChart,
    PoundSterling,
    Lightbulb,
} from "lucide-react";
import { Reveal } from "./Reveal";

const items = [
    {
        icon: Megaphone,
        title: "Google Ads campaign planning and optimisation",
    },
    { icon: UserCheck, title: "Lead capture and qualification" },
    { icon: Mail, title: "AI email follow-up" },
    { icon: LineChart, title: "Campaign and lead intelligence" },
    { icon: PoundSterling, title: "Revenue attribution" },
    {
        icon: Lightbulb,
        title: "Recommendations on what to stop, change or reinvest in",
    },
];

export const Capabilities = () => (
    <section
        data-testid="capabilities-section"
        className="bg-[#F8FAFC] py-24 lg:py-32"
    >
        <div className="mx-auto max-w-7xl px-6 lg:px-8">
            <Reveal>
                <p className="text-sm font-semibold uppercase tracking-wider text-[#2563EB]">
                    Capabilities
                </p>
                <h2 className="mt-3 max-w-2xl text-3xl font-bold tracking-tight text-[#0B1F44] lg:text-4xl">
                    What FlowPilot does.
                </h2>
            </Reveal>
            <div className="mt-14 grid grid-cols-1 gap-6 md:grid-cols-2 lg:grid-cols-3">
                {items.map((item, i) => (
                    <Reveal key={item.title} delay={i * 0.06}>
                        <div
                            data-testid={`capability-card-${i}`}
                            className="fp-card-shadow group h-full rounded-2xl border border-gray-100 bg-white p-8 transition-all hover:-translate-y-1"
                        >
                            <span className="flex h-12 w-12 items-center justify-center rounded-2xl bg-[#2563EB]/10 transition-colors group-hover:bg-[#2563EB]">
                                <item.icon className="h-6 w-6 text-[#2563EB] transition-colors group-hover:text-white" />
                            </span>
                            <h3 className="mt-6 text-lg font-semibold leading-snug text-[#0B1F44]">
                                {item.title}
                            </h3>
                        </div>
                    </Reveal>
                ))}
            </div>
        </div>
    </section>
);
